module.exports = __webpack_public_path__ + "static/media/boat-img-2-1.fa2daf16.jpg";